<template>
  <div class="big_box">
    <report-table-children-all
      :api-config="apiConfig"
      :date-field="'billDateRange'"
      data-key="data"
      :show-pagination="true"
      report-key="CompDailyRpt"
      filterMode="inline"
    />
  </div>
</template>

<script>
import { apiCompDailyRpt, apiCompDailyRptPull, apiCompDailyRptExport } from '@/request/api';

export default {
  name: 'CompDailyRpt',
  data() {
    return {
      apiConfig: {
        pull: apiCompDailyRptPull,
        getData: apiCompDailyRpt,
        exportData: apiCompDailyRptExport
      }
    };
  }
};
</script>

<style  lang="scss" scoped>
</style>
